import {Component, OnInit} from '@angular/core';
import {TermsAndPrivacyAcknowledgmentService} from './terms-and-privacy-acknowledgment.service';

@Component({
    selector: 'app-terms-and-privacy-acknowledgment',
    templateUrl: './terms-and-privacy-acknowledgment.component.html',
    styleUrls: ['./terms-and-privacy-acknowledgment.component.scss'],
    standalone: false
})
export class TermsAndPrivacyAcknowledgmentComponent implements OnInit {

  constructor(private termsAndPrivacyAcknowledgmentService: TermsAndPrivacyAcknowledgmentService) { }

  ngOnInit(): void {
  }

  close(): void {
    this.termsAndPrivacyAcknowledgmentService.acknowledge();
  }
}
